{
  "exportGeoJson": {
    "exportLayersInfo": "Les couches sélectionnées sont en cours d'exportation, nous vous ferons savoir quand elles seront prêtes"
  },
  "importGeoJson": {
    "invalidGeoJson": {
      "title": "Type de fichier non valide",
      "message": "Le fichier que vous avez chargé n'est pas valide. Veuillez charger un fichier GeoJSON, JSON, GPX ou KML/KMZ valide."
    },
    "somethingWentWrong": {
      "title": "Quelque chose s'est mal passé",
      "message": "Le type de fichier que vous avez chargé n'est pas valide. Veuillez charger un fichier GeoJSON, JSON, GPX ou KML/KMZ valide."
    },
    "fileTooLarge": {
      "title": "Taille de fichier trop importante",
      "message": "Le fichier que vous essayez de télécharger est trop volumineux. La taille de fichier maximale est {{ size }}"
    },
    "invalidGeometry": {
      "title": "Géométrie non valide",
      "message": "La géométrie du type de couche que vous essayez de charger n'est pas valide."
    },
    "invalidLayerType": {
      "title": "Type de couche incompatible",
      "message": "Vous essayez de télécharger une couche {{ importType }} vers une couche {{ layerType }}"
    },
    "invalidCoordinateSystem": {
      "title": "Système de coordonnées non pris en charge",
      "message": "Le système de coordonnées n'est pas pris en charge, veuillez utiliser {{ coordinateSystem }}"
    },
    "reuploadGeoJson": "L'extension de fichier prise en charge est {{ fileExtensions }} et la taille de fichier maximale est de {{ size }}",
    "mappedAttributeDescription": "Sélectionnez les propriétés dans le fichier à importer en tant qu'attributs de couche (facultatif).",
    "layerAttribute": "Attribut de couche",
    "type": "Tapez",
    "fieldToImport": "Champ à importer",
    "overwriteExisting": "Remplacer l'existant",
    "importLayer": "Importer une couche"
  },
  "importKML": {
    "invalidKML": {
      "title": "Données KML non valides",
      "message": "Les données KML ne sont pas valides. Vérifiez votre fichier source et réessayez."
    },
    "folderSelectLabel": "Couches d'importation par défaut",
    "allFolders": "Toutes les couches"
  },
  "importGpx": {
    "invalidGpx": {
      "title": "Données GPX non valides",
      "message": "Les données GPX ne sont pas valides. Vérifiez votre fichier source et réessayez."
    },
    "import_track": "Importer une piste",
    "import_route": "Itinéraire d'importation"
  },
  "analysis_drawing_tooltips": {
    "title": "Outils d'analyse",
    "enter_edit_mode": "Utilisez les outils de dessin pour sélectionner des objets cartographiques et analyser des zones, des lignes, etc.",
    "enter_edit_mode_link": "Cliquez ici pour en savoir plus sur cet outil"
  },
  "dataTableGrouping": {
    "checkbox": "Données de groupe"
  },
  "assets": {
    "edit": "Modifier la ressource sélectionnée",
    "delete": "Supprimer la ressource sélectionnée",
    "uploadAsset": "Télécharger un actif",
    "deleteTitleIcon": "Icône Supprimer",
    "deleteDescriptionIcon": "Êtes-vous sûr de vouloir supprimer cette icône ?",
    "deleteTitleModel": "Supprimer le modèle",
    "deleteDescriptionModel": "Êtes-vous sûr de vouloir supprimer ce mode ?"
  },
  "toolbarButtonTooltips": {
    "route": "Générateur d'itinéraires"
  },
  "routeGenerator": {
    "routeGenerator": "Générateur d'itinéraires",
    "distance": "Distance",
    "travelTime": "Temps de trajet",
    "addStop": "Ajouter un arrêt",
    "addRoute": "Nouvel itinéraire",
    "removeStop": "Supprimer l'arrêt",
    "search": "Recherchez ou cliquez sur la carte"
  },
  "exports": {
    "remarks": {
      "title": "Remarques personnalisées",
      "placeholder": "Insérez des remarques personnalisées ici",
      "error": "Les remarques sont trop longues"
    }
  },
  "styles": {
    "modelOffset": "Offset du modèle"
  },
  "attributes": {
    "imageDescription": "Vous ne pouvez télécharger qu'une seule image par attribut. Vous pouvez remplacer votre sélection ci-dessous.",
    "imageTitle": "Télécharger l'image dans l'attribut",
    "noImageSelected": "Aucun fichier sélectionné"
  },
  "layerTemplates": {
    "chosenForYou": "Choisi pour vous"
  },
  "contextMenu": {
    "addAttributeMultipleLayers": "Ajouter un attribut à tous"
  },
  "importLayers": {
    "folderOutsideMap": "Impossible d'importer un dossier depuis l'extérieur d'une carte"
  },
  "delete": {
    "multipleTitleMix": "Supprimer plusieurs éléments",
    "multipleDescriptionMix": "La suppression d'un groupe supprimera toutes les couches et leurs objets",
    "importLayerHint": "La couche importée sera uniquement supprimée de la carte et existera dans le plan d'origine",
    "multipleLayersTitle": "Supprimer plusieurs couches",
    "multipleLayersDescription": "La suppression de plusieurs calques supprimera également tous les objets qu'ils contiennent",
    "multipleImportLayersTitle": "Supprimer les couches importées",
    "singleImportLayersTitle": "Supprimer la couche importée",
    "importLayersDescription": "La suppression de la couche importée supprimera uniquement les objets de votre carte. Vous pouvez importer la couche depuis la carte liée à tout moment",
    "singleLayerTitle": "Supprimer une couche",
    "singleLayerDescription": "La suppression de cette couche supprimera également tous les objets qu'elle contient."
  }
}